import { REPORT_MARKETING_CONSENTS } from 'redux/modules/marketing-preferences/actions/types';

import { marketingConsents } from './marketing-consent-actions';

export default {
  [REPORT_MARKETING_CONSENTS]: marketingConsents,
};
